import React from "react";
import AllSubjectTopics from "../../topics/AllSubjectTopics";


function SyllabusMath() {
  return (
    <>

      <AllSubjectTopics icon="🗺️" subject="mathematics" type="syllabus" book="" />

    </>
  );
}

export default SyllabusMath; 